import z from "zod";

const fields = {
  email: {
    label: "Email",
    placeholder: "name@example.com",
    schema: z.email("Please enter a valid email"),
    type: "email",
    name: "email",
  },
  password: {
    label: "Password",
    placeholder: "••••••••",
    schema: z.string().min(6, "Password must be at least 6 characters"),
    type: "password",
    name: "password",
  },
  confirmPassword: {
    label: "Confirm Password",
    placeholder: "••••••••",
    schema: z.string().min(6, "Confirm Password must be at least 6 characters"),
    type: "password",
    name: "confirmPassword",
  },
};

const authModalData = {
  title: "Welcome",
  subtitle: "Sign in or create an account to continue",
  googleButtonLabel: "Sign in with Google",
  seperatorLabel: "OR CONTINUE WITH EMAIL",
  signin: {
    title: "Sign in",
    schema: z.object({
      email: fields.email.schema,
      password: fields.password.schema,
    }),
    fields: [fields.email, fields.password],
    submitButtonLabel: "Sign in",
  },
  signup: {
    title: "Sign up",
    schema: z
      .object({
        email: fields.email.schema,
        password: fields.password.schema,
        confirmPassword: fields.confirmPassword.schema,
      })
      .refine((data) => data.password === data.confirmPassword, {
        message: "Passwords don't match",
        path: ["confirmPassword"],
      }),
    fields: [fields.email, fields.password, fields.confirmPassword],
    submitButtonLabel: "Sign up",
  },
} as const;

export default authModalData;

export type SignInFormSchema = z.infer<typeof authModalData.signin.schema>;
export type SignUpFormSchema = z.infer<typeof authModalData.signup.schema>;
